import styled from 'styled-components';

const InputGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export default InputGroup;
